import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from '@edikk-edikk/redux';
import { Container } from 'inversify';
import { API_PAGE_NAME, PAGE_LOAD_URL } from '#page/constants';
import { LoadResponseType } from '#page/api/types';

const getApiPage = (diContainer: Container) => createApi({
  reducerPath: API_PAGE_NAME,
  baseQuery: getBaseQuery(diContainer),
  endpoints: (builder) => ({
    load: builder.query<LoadResponseType, number>({
      query: (id: number) => ({
        url: PAGE_LOAD_URL,
        params: {
          id,
        },
      }),
    }),
  }),
});

export { getApiPage };
